module.exports = __webpack_public_path__ + "static/gate-26dd08e2bb58efb91aaffb22dda86f95.jpg";